import { useEffect } from 'react';

import { useAppDispatch } from 'reduxStore/appStore';
import { fetchUser } from 'reduxStore/user/asyncActions';
import { scheduleTokenRefresh } from 'reduxStore/user/utils';

export const useFetchUser = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let active = true;
    let cancelTokenRefresh: (() => void) | undefined;

    dispatch(fetchUser())
      .unwrap()
      .then((user) => {
        if (!active) {
          return;
        }
        const expirationDate = new Date(user.expirationDate * 1000);
        cancelTokenRefresh = scheduleTokenRefresh({ expirationDate });
      });

    return () => {
      active = false;
      cancelTokenRefresh?.();
    };
  }, [dispatch]);
};
